<template>
  <el-dialog
    :title="'人员数据 - ' + userName"
    :visible.sync="userReportDialogProps.visible"
    :close-on-click-modal="false"
    class="topDialog userReportDialog"
    @close="closeDialog()"
    :close-on-press-escape="false">
    <el-tabs v-model="activeName">
      <el-tab-pane label="工时汇总" name="collectViewTab">
          <userReportDialog_Collect ref="userReportDialog_Collect" 
          :userReportDialogChildProps="userReportDialogChildProps" ></userReportDialog_Collect>
      </el-tab-pane>
       <el-tab-pane label="项目投入情况" name="projectViewTab">
        <userReportDialog_Project ref="userReportDialog_Project"
        :userReportDialogChildProps="userReportDialogChildProps" ></userReportDialog_Project>
      </el-tab-pane>
       <el-tab-pane label="任务投入情况" name="taskViewTab">
        <userReportDialog_Task ref="userReportDialog_Task" 
        :userReportDialogChildProps="userReportDialogChildProps"></userReportDialog_Task>
      </el-tab-pane>
     
    </el-tabs>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="userReportDialogProps.visible=false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import userReportDialog_Collect from "../report/userReportDialog_Collect";
import userReportDialog_Task from "../report/userReportDialog_Task";
import userReportDialog_Project from "../report/userReportDialog_Project";

export default{
    name: "userReportDialog",
    props: ["userReportDialogProps"],
    components: {userReportDialog_Collect ,userReportDialog_Task,userReportDialog_Project},
    data(){
        return {
          userReportDialogChildProps: {
            userId:""
          },
            activeName:"collectViewTab",
            userName:"",
            userId:""
        }   
    },
    mounted() {

    },
    methods: {
       show(id){
           this.userReportDialogProps.visible = true;
           this.userId = id;
           this.userReportDialogChildProps.userId = id;
          this.getUser(id);

           this.$nextTick(() => {
              this.$refs.userReportDialog_Collect.show();
               this.$refs.userReportDialog_Task.show();
               this.$refs.userReportDialog_Project.show();
            })
       },

       closeDialog(){

          this.activeName = "collectViewTab";
          this.userName = "";
          this.userId = "";

           this.$refs.userReportDialog_Collect.clear();
           this.$refs.userReportDialog_Task.clear();
           this.$refs.userReportDialog_Project.clear();
       },

        getUser(id){
            this.$userApi.getUser(id).then(res => 
            {
                if (res.data.successful) 
                {
                    this.userName = res.data.data.name;
                }
            });
        }
    },
}


</script>

<style  rel="stylesheet/scss" lang="scss">

.userReportDialog .el-dialog{
    top: 2vh !important;
    bottom: 2vh !important;
    left: 10% !important;
    right: 10% !important;
    width: 80% !important;

     .el-tabs{
      //  background-color:cornflowerblue;
      //  min-height: calc(100vh - 250px) !important;
        top: 10px;
        bottom: 0px;
        left: 20px;
        right: 20px;
        position: absolute;
    }

    .el-tabs__content{
        top: 60px ;
        bottom: 0px ;
        left: 10px  ;
        right: 10px ;
        position: absolute  !important;
    }

    .el-tab-pane{
      //  background-color:aqua  !important;
          // height: 100%;
        top: 0px  !important;
        bottom: 0px  !important;
        left: 0px  !important;
        right: 0px  !important;
        position: absolute  !important;
        overflow: auto;
    }
}



</style>


// WEBPACK FOOTER //
// src/views/report/userReportDialog.vue